// pp-company.js — resuelve la empresa del cliente y la refleja en el rail.
//
// El vínculo empresa↔persona vive en el CRM, así que se resuelve por JS vía el
// App Proxy /apps/crm/customer-company. Si el cliente pertenece a una empresa,
// muestra "🏢 <empresa>" en lugar del tier del sidebar y revela el item "Mi
// Empresa". Si no, deja todo como está (cero regresión). Cachea la respuesta en
// sessionStorage (misma que consume la página "Mi Empresa"). Se carga desde el
// rail → corre en todas las páginas del account. Fase 1 del feature B2B.

(function () {
  'use strict';

  var ENDPOINT = '/apps/crm/customer-company';
  // Cache aislado por cliente: sessionStorage persiste tras logout/login en la
  // misma pestaña, así que la key lleva el customer.id para no filtrar la empresa
  // de un usuario al siguiente.
  // v2 (2026-07-17): pestañas abiertas antes del router del App Proxy cachearon
  // la respuesta fiscal bajo el key v1 y sessionStorage no expira hasta cerrar la
  // pestaña; el bump invalida todos esos caches de un jalón.
  // v3 (2026-07-18): la respuesta trae datos de empresa nuevos (Mi Empresa los
  // edita); bump para no servir cache v2 sin esos campos.
  // v4 (2026-09-08): la respuesta trae `tiene_precios` y de él depende que salga
  // «Mis precios» en el rail. Sin bump, quien tenga la pestaña abierta sirve un
  // cache v3 sin ese campo y el item desaparecería para él aunque sí tenga
  // pactos. (Desde el 1-oct-2026 «Mis precios» ya no existe y nadie lee
  // `tiene_precios`; el campo sigue viajando y no estorba.) Es la tercera vez que un campo nuevo obliga al bump: si mañana le
  // cuelgas otro campo a este endpoint, sube la v.
  var railEl = document.querySelector('[data-pp-customer]');
  // v5 (7-oct-2026): el teléfono del ejecutivo ahora es SÓLO el corporativo;
  // la llave nueva tira lo guardado con el personal.
  var CACHE_KEY = 'pp_company_v6:' + ((railEl && railEl.getAttribute('data-pp-customer')) || 'anon');

  var tier = document.querySelector('[data-pp-rail-tier]');
  var slot = document.querySelector('[data-pp-rail-company]');
  var item = document.querySelector('[data-pp-rail-company-item]');
  // «Mi Empresa» vive en DOS superficies desde el 25-sep-2026: el
  // rail (escritorio) y la hoja «Más» (teléfono, donde el rail es
  // display:none). Revelar solo una deja al mismo cliente con dos respuestas
  // distintas segun el aparato — y en el teléfono la respuesta equivocada es
  // la visible, porque ahí el destino arranca oculto y se quedaría así.
  var companyItemMas = document.querySelector('[data-pp-cmas-company-item]');
  // Menu de seis (1-oct-2026): «Mis Estadísticas» es la gemela de «Mi Empresa» para
  // quien no tiene empresa. Al revelar una se esconde la otra, en las dos
  // superficies — y la pestaña «Resumen» de la familia solo existe con empresa.
  var cuentaItem = document.querySelector('[data-pp-rail-misest-item]');
  var cuentaItemMas = document.querySelector('[data-pp-cmas-misest-item]');
  var tabEmpresa = document.querySelector('[data-pp-tabs-company-item]');
  if (!slot && !item && !companyItemMas && !tabEmpresa) return;

  function apply(d) {
    if (!d || !d.found || !d.company || !d.company.name) return; // sin empresa → nada
    if (slot) { slot.textContent = '🏢 ' + d.company.name; slot.hidden = false; }
    if (tier) tier.hidden = true;
    if (item) item.hidden = false;
    if (companyItemMas) companyItemMas.hidden = false;
    if (cuentaItem) cuentaItem.hidden = true;
    if (cuentaItemMas) cuentaItemMas.hidden = true;
    if (tabEmpresa) tabEmpresa.hidden = false;
  }

  // Cache de sesión (la comparte la página "Mi Empresa").
  try {
    var cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) { apply(JSON.parse(cached)); return; }
  } catch (_) {}

  // En el editor del theme no hay sesión de cliente.
  if (window.Shopify && window.Shopify.designMode) return;

  // Origen del JSON: la capa PPAccount (prefetch + dedup, arranca en el parse)
  // si existe; si no, fetch directo — así otras páginas sin PPAccount no rompen.
  (window.PPAccount
    ? window.PPAccount.get('customer-company')
    : fetch(ENDPOINT, { method: 'GET', credentials: 'same-origin' }).then(function (r) { return r.json().catch(function () { return null; }); }))
    .then(function (d) {
      // Solo cachear respuestas con la forma de empresa ({found, company, ...});
      // una forma ajena (p.ej. la fiscal) no debe envenenar el cache de la sesión.
      if (!d || !('company' in d)) return;
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(d)); } catch (_) {}
      apply(d);
    })
    .catch(function () {});
})();
